import { createTheme } from "@mui/material";

// Soft, modern glassmorphism shadows
const customShadows = [
  'none',
  '0px 2px 8px rgba(0,0,0,0.04)',
  '0px 4px 16px rgba(0,0,0,0.06)',
  '0px 8px 24px rgba(0,0,0,0.08)',
  '0px 12px 32px rgba(0,0,0,0.1)',
  '0px 16px 40px rgba(0,0,0,0.12)',
  '0px 24px 48px rgba(0,0,0,0.14)',
];
// Ensure array is exactly 25 elements long for MUI
customShadows.length = 25;
customShadows.fill('none', 7, 25);

const theme = createTheme({
  palette: {
    primary: {
      main: "#2E7D32", // Richer, more vibrant emerald green
      light: "#4CAF50",
      dark: "#1B5E20",
      contrastText: "#ffffff"
    },
    secondary: {
      main: "#D4AF37", // Elegant gold accent
      light: "#F3E5AB",
      contrastText: "#000000"
    },
    background: {
      default: "#FAFAFA", // Softer off-white
      paper: "#ffffff"
    },
    text: {
      primary: "#1A202C", // Softer dark slate
      main: "#1A202C",
      secondary: "#4A5568", // Subtle gray
      shadow: "#E2E8F0"
    }
  },
  shape: {
    borderRadius: 12, // More rounded, modern feel
  },
  shadows: customShadows,
  typography: {
    fontFamily: "'Inter', 'Poppins', sans-serif", // 'Inter' for cleaner numbers/body, fallback to Poppins
    h1: { fontWeight: 700, letterSpacing: '-0.02em' },
    h2: { fontWeight: 600, letterSpacing: '-0.01em' },
    h3: { fontWeight: 600, letterSpacing: '-0.01em' },
    button: { textTransform: 'none', fontWeight: 600 }, // Modern buttons aren't ALL CAPS
    body1: { fontWeight: 400, fontSize: '1rem', lineHeight: 1.6 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          transition: 'all 0.2s ease-in-out',
        },
        contained: {
          padding: '8px 20px',
          boxShadow: '0px 2px 4px rgba(0,0,0,0.05)',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0px 4px 12px rgba(46, 125, 50, 0.2)', // Green tinted shadow
          },
        },
        containedSecondary: {
          '&:hover': {
            boxShadow: '0px 4px 12px rgba(212, 175, 55, 0.3)', // Gold tinted shadow
          }
        }
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0px 8px 24px rgba(0,0,0,0.06)', // Soft shadow
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0px 12px 32px rgba(0,0,0,0.1)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        elevation1: {
          boxShadow: '0px 4px 16px rgba(0,0,0,0.05)',
        },
        elevation2: {
          boxShadow: '0px 8px 24px rgba(0,0,0,0.06)',
        }
      }
    }
  }
});

export default theme;